var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMoneyNew1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2001_771)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.3674,
    width: 19,
    height: 4,
    rx: 2,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.79834,
    y: 13.8821,
    width: 18.6989,
    height: 5.58947,
    rx: 2.79474,
    transform: "rotate(-35 2.79834 13.8821)",
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15.3674,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19.3674,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 23.3674,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 18.8674,
    rx: 8,
    ry: 8.5,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10.3674,
    width: 19,
    height: 4,
    rx: 2,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.79834,
    y: 12.8821,
    width: 18.6989,
    height: 5.58947,
    rx: 2.79474,
    transform: "rotate(-35 2.79834 12.8821)",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14.3674,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18.3674,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22.3674,
    width: 18,
    height: 4,
    rx: 2,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 17.8674,
    rx: 8,
    ry: 8.5,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 18.6567,
    rx: 7,
    ry: 5.5,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 17.6567,
    rx: 7,
    ry: 5.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6992 20.1567L13.1953 14.854H14.4648L15.4023 18.5845H15.4512L16.3984 14.854H17.6582L18.6152 18.5649H18.6641L19.5918 14.854H20.8613L19.3574 20.1567H18.0586L17.0625 16.563H16.9941L15.998 20.1567H14.6992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2001_771",
    x: -1.5,
    y: 0.156738,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2001_771"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2001_771",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoneyNew1);
export default __webpack_public_path__ + "static/media/IcMoneyNew_1.59246d989bb6303dd46f1f93cdd15b03.svg";
export { ForwardRef as ReactComponent };